import type { ISOCountryGeo } from "../types.js";

export const countriesGeo: ISOCountryGeo = {
	AX: {
		capital: "Mariehamn",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
	},
	AF: {
		capital: "Kabul",
		region: "Asia",
		continent: "AS",
		subRegion: "Southern Asia",
		nameFormal: "the Islamic Republic of Afghanistan",
	},
	AL: {
		capital: "Tirana",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Republic of Albania",
	},
	DZ: {
		capital: "Algiers",
		region: "Africa",
		continent: "AF",
		subRegion: "Northern Africa",
		nameFormal: "the People's Democratic Republic of Algeria",
	},
	AS: {
		capital: "Pago Pago",
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
	},
	AD: {
		capital: "Andorra la Vella",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Principality of Andorra",
	},
	AO: {
		capital: "Luanda",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Middle Africa",
		nameFormal: "the Republic of Angola",
	},
	AQ: {
		region: "Antarctica",
		continent: "AN",
		subRegion: "Antarctica",
	},
	AI: {
		capital: "The Valley",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	AG: {
		capital: "St. John's",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "Antigua and Barbuda",
	},
	AR: {
		capital: "Buenos Aires",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Argentine Republic",
	},
	AM: {
		capital: "Yerevan",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Republic of Armenia",
	},
	AW: {
		capital: "Oranjestad",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	AU: {
		capital: "Canberra",
		region: "Oceania",
		continent: "OC",
		subRegion: "Australia and New Zealand",
		nameFormal: "Australia",
	},
	AT: {
		capital: "Vienna",
		region: "Europe",
		continent: "EU",
		subRegion: "Western Europe",
		nameFormal: "the Republic of Austria",
	},
	AZ: {
		capital: "Baku",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Republic of Azerbaijan",
	},
	BS: {
		capital: "Nassau",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "the Commonwealth of the Bahamas",
	},
	BH: {
		capital: "Manama",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Kingdom of Bahrain",
	},
	BD: {
		capital: "Dhaka",
		region: "Asia",
		continent: "AS",
		subRegion: "Southern Asia",
		nameFormal: "the People's Republic of Bangladesh",
	},
	BB: {
		capital: "Bridgetown",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "Barbados",
	},
	BY: {
		capital: "Minsk",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "the Republic of Belarus",
	},
	BE: {
		capital: "Brussels",
		region: "Europe",
		continent: "EU",
		subRegion: "Western Europe",
		nameFormal: "the Kingdom of Belgium",
	},
	BZ: {
		capital: "Belmopan",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Central America",
		nameFormal: "Belize",
	},
	BJ: {
		capital: "Porto-Novo",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of Benin",
	},
	BM: {
		capital: "Hamilton",
		region: "Americas",
		continent: "NA",
		subRegion: "Northern America",
	},
	BT: {
		capital: "Thimphu",
		region: "Asia",
		continent: "AS",
		subRegion: "Southern Asia",
		nameFormal: "the Kingdom of Bhutan",
	},
	BO: {
		capital: "Sucre",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Plurinational State of Bolivia",
	},
	BQ: {
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	BA: {
		capital: "Sarajevo",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "Bosnia and Herzegovina",
	},
	BW: {
		capital: "Gaborone",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Southern Africa",
		nameFormal: "the Republic of Botswana",
	},
	BV: {
		region: "Americas",
		continent: "AN",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
	},
	BR: {
		capital: "Brasilia",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Federative Republic of Brazil",
	},
	IO: {
		capital: "Diego Garcia",
		region: "Africa",
		continent: "AS",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
	},
	VG: {
		capital: "Road Town",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	BN: {
		capital: "Bandar Seri Begawan",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "Brunei Darussalam",
	},
	BG: {
		capital: "Sofia",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "the Republic of Bulgaria",
	},
	BF: {
		capital: "Ouagadougou",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "Burkina Faso",
	},
	BI: {
		capital: "Bujumbura",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Burundi",
	},
	CV: {
		capital: "Praia",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of Cabo Verde",
	},
	KH: {
		capital: "Phnom Penh",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "the Kingdom of Cambodia",
	},
	CM: {
		capital: "Yaounde",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Middle Africa",
		nameFormal: "the Republic of Cameroon",
	},
	CA: {
		capital: "Ottawa",
		region: "Americas",
		continent: "NA",
		subRegion: "Northern America",
		nameFormal: "Canada",
	},
	KY: {
		capital: "George Town",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	CF: {
		capital: "Bangui",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Middle Africa",
		nameFormal: "the Central African Republic",
	},
	TD: {
		capital: "N'Djamena",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Middle Africa",
		nameFormal: "the Republic of Chad",
	},
	CL: {
		capital: "Santiago",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Republic of Chile",
	},
	CN: {
		capital: "Beijing",
		region: "Asia",
		continent: "AS",
		subRegion: "Eastern Asia",
		nameFormal: "the People's Republic of China",
	},
	HK: {
		capital: "Hong Kong",
		region: "Asia",
		continent: "AS",
		subRegion: "Eastern Asia",
	},
	MO: {
		capital: "Macao",
		region: "Asia",
		continent: "AS",
		subRegion: "Eastern Asia",
	},
	CX: {
		capital: "Flying Fish Cove",
		region: "Oceania",
		continent: "OC",
		subRegion: "Australia and New Zealand",
	},
	CC: {
		capital: "West Island",
		region: "Oceania",
		continent: "AS",
		subRegion: "Australia and New Zealand",
	},
	CO: {
		capital: "Bogota",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Republic of Colombia",
	},
	KM: {
		capital: "Moroni",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Union of the Comoros",
	},
	CG: {
		capital: "Brazzaville",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Middle Africa",
		nameFormal: "the Republic of the Congo",
	},
	CK: {
		capital: "Avarua",
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
		nameFormal: "the Cook Islands",
	},
	CR: {
		capital: "San Jose",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Central America",
		nameFormal: "the Republic of Costa Rica",
	},
	HR: {
		capital: "Zagreb",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Republic of Croatia",
	},
	CU: {
		capital: "Havana",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "the Republic of Cuba",
	},
	CW: {
		capital: "Willemstad",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	CY: {
		capital: "Nicosia",
		region: "Asia",
		continent: "EU",
		subRegion: "Western Asia",
		nameFormal: "the Republic of Cyprus",
	},
	CZ: {
		capital: "Prague",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "the Czech Republic",
	},
	CI: {
		capital: "Yamoussoukro",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of C\\u00f4te d'Ivoire",
	},
	KP: {
		capital: "Pyongyang",
		region: "Asia",
		continent: "AS",
		subRegion: "Eastern Asia",
		nameFormal: "the Democratic People's Republic of Korea",
	},
	CD: {
		capital: "Kinshasa",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Middle Africa",
		nameFormal: "the Democratic Republic of the Congo",
	},
	DK: {
		capital: "Copenhagen",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "the Kingdom of Denmark",
	},
	DJ: {
		capital: "Djibouti",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Djibouti",
	},
	DM: {
		capital: "Roseau",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "the Commonwealth of Dominica",
	},
	DO: {
		capital: "Santo Domingo",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "the Dominican Republic",
	},
	EC: {
		capital: "Quito",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Republic of Ecuador",
	},
	EG: {
		capital: "Cairo",
		region: "Africa",
		continent: "AF",
		subRegion: "Northern Africa",
		nameFormal: "the Arab Republic of Egypt",
	},
	SV: {
		capital: "San Salvador",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Central America",
		nameFormal: "the Republic of El Salvador",
	},
	GQ: {
		capital: "Malabo",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Middle Africa",
		nameFormal: "the Republic of Equatorial Guinea",
	},
	ER: {
		capital: "Asmara",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the State of Eritrea",
	},
	EE: {
		capital: "Tallinn",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "the Republic of Estonia",
	},
	SZ: {
		capital: "Mbabane",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Southern Africa",
	},
	ET: {
		capital: "Addis Ababa",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Federal Democratic Republic of Ethiopia",
	},
	FK: {
		capital: "Stanley",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
	},
	FO: {
		capital: "Torshavn",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
	},
	FJ: {
		capital: "Suva",
		region: "Oceania",
		continent: "OC",
		subRegion: "Melanesia",
		nameFormal: "the Republic of Fiji",
	},
	FI: {
		capital: "Helsinki",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "the Republic of Finland",
	},
	FR: {
		capital: "Paris",
		region: "Europe",
		continent: "EU",
		subRegion: "Western Europe",
		nameFormal: "the French Republic",
	},
	GF: {
		capital: "Cayenne",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
	},
	PF: {
		capital: "Papeete",
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
	},
	TF: {
		capital: "Port-aux-Francais",
		region: "Africa",
		continent: "AN",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
	},
	GA: {
		capital: "Libreville",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Middle Africa",
		nameFormal: "the Gabonese Republic",
	},
	GM: {
		capital: "Banjul",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of the Gambia",
	},
	GE: {
		capital: "Tbilisi",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "Georgia",
	},
	DE: {
		capital: "Berlin",
		region: "Europe",
		continent: "EU",
		subRegion: "Western Europe",
		nameFormal: "the Federal Republic of Germany",
	},
	GH: {
		capital: "Accra",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of Ghana",
	},
	GI: {
		capital: "Gibraltar",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
	},
	GR: {
		capital: "Athens",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Hellenic Republic",
	},
	GL: {
		capital: "Nuuk",
		region: "Americas",
		continent: "NA",
		subRegion: "Northern America",
	},
	GD: {
		capital: "St. George's",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "Grenada",
	},
	GP: {
		capital: "Basse-Terre",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	GU: {
		capital: "Hagatna",
		region: "Oceania",
		continent: "OC",
		subRegion: "Micronesia",
	},
	GT: {
		capital: "Guatemala City",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Central America",
		nameFormal: "the Republic of Guatemala",
	},
	GG: {
		capital: "St Peter Port",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		intermediateRegion: "Channel Islands",
	},
	GN: {
		capital: "Conakry",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of Guinea",
	},
	GW: {
		capital: "Bissau",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of Guinea-Bissau",
	},
	GY: {
		capital: "Georgetown",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Republic of Guyana",
	},
	HT: {
		capital: "Port-au-Prince",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "the Republic of Haiti",
	},
	HM: {
		region: "Oceania",
		continent: "AN",
		subRegion: "Australia and New Zealand",
	},
	VA: {
		capital: "Vatican City",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Holy See",
	},
	HN: {
		capital: "Tegucigalpa",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Central America",
		nameFormal: "the Republic of Honduras",
	},
	HU: {
		capital: "Budapest",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "Hungary",
	},
	IS: {
		capital: "Reykjavik",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "the Republic of Iceland",
	},
	IN: {
		capital: "New Delhi",
		region: "Asia",
		continent: "AS",
		subRegion: "Southern Asia",
		nameFormal: "the Republic of India",
	},
	ID: {
		capital: "Jakarta",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "the Republic of Indonesia",
	},
	IR: {
		capital: "Tehran",
		region: "Asia",
		continent: "AS",
		subRegion: "Southern Asia",
		nameFormal: "the Islamic Republic of Iran",
	},
	IQ: {
		capital: "Baghdad",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Republic of Iraq",
	},
	IE: {
		capital: "Dublin",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "Ireland",
	},
	IM: {
		capital: "Douglas",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
	},
	IL: {
		capital: "Jerusalem",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the State of Israel",
	},
	IT: {
		capital: "Rome",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Republic of Italy",
	},
	JM: {
		capital: "Kingston",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "Jamaica",
	},
	JP: {
		capital: "Tokyo",
		region: "Asia",
		continent: "AS",
		subRegion: "Eastern Asia",
		nameFormal: "Japan",
	},
	JE: {
		capital: "Saint Helier",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		intermediateRegion: "Channel Islands",
	},
	JO: {
		capital: "Amman",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Hashemite Kingdom of Jordan",
	},
	KZ: {
		capital: "Astana",
		region: "Asia",
		continent: "AS",
		subRegion: "Central Asia",
		nameFormal: "the Republic of Kazakhstan",
	},
	KE: {
		capital: "Nairobi",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Kenya",
	},
	KI: {
		capital: "Tarawa",
		region: "Oceania",
		continent: "OC",
		subRegion: "Micronesia",
		nameFormal: "the Republic of Kiribati",
	},
	KW: {
		capital: "Kuwait City",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the State of Kuwait",
	},
	KG: {
		capital: "Bishkek",
		region: "Asia",
		continent: "AS",
		subRegion: "Central Asia",
		nameFormal: "the Kyrgyz Republic",
	},
	LA: {
		capital: "Vientiane",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "the Lao People's Democratic Republic",
	},
	LV: {
		capital: "Riga",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "the Republic of Latvia",
	},
	LB: {
		capital: "Beirut",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Lebanese Republic",
	},
	LS: {
		capital: "Maseru",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Southern Africa",
		nameFormal: "the Kingdom of Lesotho",
	},
	LR: {
		capital: "Monrovia",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of Liberia",
	},
	LY: {
		capital: "Tripoli",
		region: "Africa",
		continent: "AF",
		subRegion: "Northern Africa",
		nameFormal: "Libya",
	},
	LI: {
		capital: "Vaduz",
		region: "Europe",
		continent: "EU",
		subRegion: "Western Europe",
		nameFormal: "the Principality of Liechtenstein",
	},
	LT: {
		capital: "Vilnius",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "the Republic of Lithuania",
	},
	LU: {
		capital: "Luxembourg",
		region: "Europe",
		continent: "EU",
		subRegion: "Western Europe",
		nameFormal: "the Grand Duchy of Luxembourg",
	},
	MG: {
		capital: "Antananarivo",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Madagascar",
	},
	MW: {
		capital: "Lilongwe",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Malawi",
	},
	MY: {
		capital: "Kuala Lumpur",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "Malaysia",
	},
	MV: {
		capital: "Male",
		region: "Asia",
		continent: "AS",
		subRegion: "Southern Asia",
		nameFormal: "the Republic of Maldives",
	},
	ML: {
		capital: "Bamako",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of Mali",
	},
	MT: {
		capital: "Valletta",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Republic of Malta",
	},
	MH: {
		capital: "Majuro",
		region: "Oceania",
		continent: "OC",
		subRegion: "Micronesia",
		nameFormal: "the Republic of the Marshall Islands",
	},
	MQ: {
		capital: "Fort-de-France",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	MR: {
		capital: "Nouakchott",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Islamic Republic of Mauritania",
	},
	MU: {
		capital: "Port Louis",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Mauritius",
	},
	YT: {
		capital: "Mamoudzou",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
	},
	MX: {
		capital: "Mexico City",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Central America",
		nameFormal: "the United Mexican States",
	},
	FM: {
		capital: "Palikir",
		region: "Oceania",
		continent: "OC",
		subRegion: "Micronesia",
		nameFormal: "the Federated States of Micronesia",
	},
	MC: {
		capital: "Monaco",
		region: "Europe",
		continent: "EU",
		subRegion: "Western Europe",
		nameFormal: "the Principality of Monaco",
	},
	MN: {
		capital: "Ulan Bator",
		region: "Asia",
		continent: "AS",
		subRegion: "Eastern Asia",
		nameFormal: "Mongolia",
	},
	ME: {
		capital: "Podgorica",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "Montenegro",
	},
	MS: {
		capital: "Plymouth",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	MA: {
		capital: "Rabat",
		region: "Africa",
		continent: "AF",
		subRegion: "Northern Africa",
		nameFormal: "the Kingdom of Morocco",
	},
	MZ: {
		capital: "Maputo",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Mozambique",
	},
	MM: {
		capital: "Nay Pyi Taw",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "the Republic of the Union of Myanmar",
	},
	NA: {
		capital: "Windhoek",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Southern Africa",
		nameFormal: "the Republic of Namibia",
	},
	NR: {
		capital: "Yaren",
		region: "Oceania",
		continent: "OC",
		subRegion: "Micronesia",
		nameFormal: "the Republic of Nauru",
	},
	NP: {
		capital: "Kathmandu",
		region: "Asia",
		continent: "AS",
		subRegion: "Southern Asia",
		nameFormal: "the Federal Democratic Republic of Nepal",
	},
	NL: {
		capital: "Amsterdam",
		region: "Europe",
		continent: "EU",
		subRegion: "Western Europe",
		nameFormal: "the Kingdom of the Netherlands",
	},
	NC: {
		capital: "Noumea",
		region: "Oceania",
		continent: "OC",
		subRegion: "Melanesia",
	},
	NZ: {
		capital: "Wellington",
		region: "Oceania",
		continent: "OC",
		subRegion: "Australia and New Zealand",
		nameFormal: "New Zealand",
	},
	NI: {
		capital: "Managua",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Central America",
		nameFormal: "the Republic of Nicaragua",
	},
	NE: {
		capital: "Niamey",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of the Niger",
	},
	NG: {
		capital: "Abuja",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Federal Republic of Nigeria",
	},
	NU: {
		capital: "Alofi",
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
		nameFormal: "Niue",
	},
	NF: {
		capital: "Kingston",
		region: "Oceania",
		continent: "OC",
		subRegion: "Australia and New Zealand",
	},
	MP: {
		capital: "Saipan",
		region: "Oceania",
		continent: "OC",
		subRegion: "Micronesia",
	},
	NO: {
		capital: "Oslo",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "the Kingdom of Norway",
	},
	OM: {
		capital: "Muscat",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Sultanate of Oman",
	},
	PK: {
		capital: "Islamabad",
		region: "Asia",
		continent: "AS",
		subRegion: "Southern Asia",
		nameFormal: "the Islamic Republic of Pakistan",
	},
	PW: {
		capital: "Melekeok",
		region: "Oceania",
		continent: "OC",
		subRegion: "Micronesia",
		nameFormal: "the Republic of Palau",
	},
	PA: {
		capital: "Panama City",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Central America",
		nameFormal: "the Republic of Panama",
	},
	PG: {
		capital: "Port Moresby",
		region: "Oceania",
		continent: "OC",
		subRegion: "Melanesia",
		nameFormal: "Independent State of Papua New Guinea",
	},
	PY: {
		capital: "Asuncion",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Republic of Paraguay",
	},
	PE: {
		capital: "Lima",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Republic of Peru",
	},
	PH: {
		capital: "Manila",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "the Republic of the Philippines",
	},
	PN: {
		capital: "Adamstown",
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
	},
	PL: {
		capital: "Warsaw",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "the Republic of Poland",
	},
	PT: {
		capital: "Lisbon",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Portuguese Republic",
	},
	PR: {
		capital: "San Juan",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	QA: {
		capital: "Doha",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the State of Qatar",
	},
	KR: {
		capital: "Seoul",
		region: "Asia",
		continent: "AS",
		subRegion: "Eastern Asia",
		nameFormal: "the Republic of Korea",
	},
	MD: {
		capital: "Chisinau",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "the Republic of Moldova",
	},
	RO: {
		capital: "Bucharest",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "Romania",
	},
	RU: {
		capital: "Moscow",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "the Russian Federation",
	},
	RW: {
		capital: "Kigali",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Rwanda",
	},
	RE: {
		capital: "Saint-Denis",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
	},
	BL: {
		capital: "Gustavia",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	SH: {
		capital: "Jamestown",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
	},
	KN: {
		capital: "Basseterre",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "Saint Kitts and Nevis",
	},
	LC: {
		capital: "Castries",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "Saint Lucia",
	},
	MF: {
		capital: "Marigot",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	PM: {
		capital: "Saint-Pierre",
		region: "Americas",
		continent: "NA",
		subRegion: "Northern America",
	},
	VC: {
		capital: "Kingstown",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "Saint Vincent and the Grenadines",
	},
	WS: {
		capital: "Apia",
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
		nameFormal: "the Independent State of Samoa",
	},
	SM: {
		capital: "San Marino",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Republic of San Marino",
	},
	ST: {
		capital: "Sao Tome",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Middle Africa",
		nameFormal: "the Democratic Republic of Sao Tome and Principe",
	},
	SA: {
		capital: "Riyadh",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Kingdom of Saudi Arabia",
	},
	SN: {
		capital: "Dakar",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of Senegal",
	},
	RS: {
		capital: "Belgrade",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Republic of Serbia",
	},
	SC: {
		capital: "Victoria",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Seychelles",
	},
	SL: {
		capital: "Freetown",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Republic of Sierra Leone",
	},
	SG: {
		capital: "Singapore",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "the Republic of Singapore",
	},
	SX: {
		capital: "Philipsburg",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	SK: {
		capital: "Bratislava",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "the Slovak Republic",
	},
	SI: {
		capital: "Ljubljana",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Republic of Slovenia",
	},
	SB: {
		capital: "Honiara",
		region: "Oceania",
		continent: "OC",
		subRegion: "Melanesia",
		nameFormal: "Solomon Islands",
	},
	SO: {
		capital: "Mogadishu",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Federal Republic of Somalia",
	},
	ZA: {
		capital: "Pretoria",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Southern Africa",
		nameFormal: "the Republic of South Africa",
	},
	GS: {
		capital: "Grytviken",
		region: "Americas",
		continent: "AN",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
	},
	SS: {
		capital: "Juba",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of South Sudan",
	},
	ES: {
		capital: "Madrid",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Kingdom of Spain",
	},
	LK: {
		capital: "Colombo",
		region: "Asia",
		continent: "AS",
		subRegion: "Southern Asia",
		nameFormal: "the Democratic Socialist Republic of Sri Lanka",
	},
	PS: {
		capital: "East Jerusalem",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "State of Palestine",
	},
	SD: {
		capital: "Khartoum",
		region: "Africa",
		continent: "AF",
		subRegion: "Northern Africa",
		nameFormal: "the Republic of the Sudan",
	},
	SR: {
		capital: "Paramaribo",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Republic of Suriname",
	},
	SJ: {
		capital: "Longyearbyen",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
	},
	SE: {
		capital: "Stockholm",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "the Kingdom of Sweden",
	},
	CH: {
		capital: "Bern",
		region: "Europe",
		continent: "EU",
		subRegion: "Western Europe",
		nameFormal: "the Swiss Confederation",
	},
	SY: {
		capital: "Damascus",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Syrian Arab Republic",
	},
	TJ: {
		capital: "Dushanbe",
		region: "Asia",
		continent: "AS",
		subRegion: "Central Asia",
		nameFormal: "the Republic of Tajikistan",
	},
	TH: {
		capital: "Bangkok",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "the Kingdom of Thailand",
	},
	MK: {
		capital: "Skopje",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the former Yugoslav Republic of Macedonia",
	},
	TL: {
		capital: "Dili",
		region: "Asia",
		continent: "OC",
		subRegion: "South-eastern Asia",
		nameFormal: "the Democratic Republic of Timor-Leste",
	},
	TG: {
		capital: "Lome",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Western Africa",
		nameFormal: "the Togolese Republic",
	},
	TK: {
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
	},
	TO: {
		capital: "Nuku'alofa",
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
		nameFormal: "the Kingdom of Tonga",
	},
	TT: {
		capital: "Port of Spain",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
		nameFormal: "the Republic of Trinidad and Tobago",
	},
	TN: {
		capital: "Tunis",
		region: "Africa",
		continent: "AF",
		subRegion: "Northern Africa",
		nameFormal: "the Republic of Tunisia",
	},
	TR: {
		capital: "Ankara",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Republic of Turkey",
	},
	TM: {
		capital: "Ashgabat",
		region: "Asia",
		continent: "AS",
		subRegion: "Central Asia",
		nameFormal: "Turkmenistan",
	},
	TC: {
		capital: "Cockburn Town",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	TV: {
		capital: "Funafuti",
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
		nameFormal: "Tuvalu",
	},
	UG: {
		capital: "Kampala",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Uganda",
	},
	UA: {
		capital: "Kyiv",
		region: "Europe",
		continent: "EU",
		subRegion: "Eastern Europe",
		nameFormal: "Ukraine",
	},
	AE: {
		capital: "Abu Dhabi",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the United Arab Emirates",
	},
	GB: {
		capital: "London",
		region: "Europe",
		continent: "EU",
		subRegion: "Northern Europe",
		nameFormal: "the United Kingdom of Great Britain and Northern Ireland",
	},
	TZ: {
		capital: "Dodoma",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the United Republic of Tanzania",
	},
	XK: {
		capital: "Pristina",
		region: "Europe",
		continent: "EU",
		subRegion: "Southern Europe",
		nameFormal: "the Republic of Kosovo",
	},
	TW: {
		capital: "Taipei",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
	},
	UM: {
		region: "Oceania",
		continent: "OC",
		subRegion: "Micronesia",
	},
	VI: {
		capital: "Charlotte Amalie",
		region: "Americas",
		continent: "NA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "Caribbean",
	},
	US: {
		capital: "Washington",
		region: "Americas",
		continent: "NA",
		subRegion: "Northern America",
		nameFormal: "the United States of America",
	},
	UY: {
		capital: "Montevideo",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Eastern Republic of Uruguay",
	},
	UZ: {
		capital: "Tashkent",
		region: "Asia",
		continent: "AS",
		subRegion: "Central Asia",
		nameFormal: "the Republic of Uzbekistan",
	},
	VU: {
		capital: "Port Vila",
		region: "Oceania",
		continent: "OC",
		subRegion: "Melanesia",
		nameFormal: "the Republic of Vanuatu",
	},
	VE: {
		capital: "Caracas",
		region: "Americas",
		continent: "SA",
		subRegion: "Latin America and the Caribbean",
		intermediateRegion: "South America",
		nameFormal: "the Bolivarian Republic of Venezuela",
	},
	VN: {
		capital: "Hanoi",
		region: "Asia",
		continent: "AS",
		subRegion: "South-eastern Asia",
		nameFormal: "the Socialist Republic of Viet Nam",
	},
	WF: {
		capital: "Mata Utu",
		region: "Oceania",
		continent: "OC",
		subRegion: "Polynesia",
	},
	EH: {
		capital: "El-Aaiun",
		region: "Africa",
		continent: "AF",
		subRegion: "Northern Africa",
	},
	YE: {
		capital: "Sanaa",
		region: "Asia",
		continent: "AS",
		subRegion: "Western Asia",
		nameFormal: "the Republic of Yemen",
	},
	ZM: {
		capital: "Lusaka",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Zambia",
	},
	ZW: {
		capital: "Harare",
		region: "Africa",
		continent: "AF",
		subRegion: "Sub-Saharan Africa",
		intermediateRegion: "Eastern Africa",
		nameFormal: "the Republic of Zimbabwe",
	},
};
